import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { OfflineOverlay } from './components/offline-overlay';
import { reloadOnDeploy } from './lib/reload-on-deploy';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element - index.html and main.tsx disagree.');

reloadOnDeploy();

createRoot(root).render(
  <StrictMode>
    <App />
    <OfflineOverlay />
  </StrictMode>,
);

// Only serves offline.html when a page load fails; see public/sw.js.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js');
}
